// angular.module('app')
// .directive('fbSrc', ['$log', function ($log) {
//   // Used to embed images stored in Firebase

//   /*
//   Required attributes:
//     fp-src (The name of an image stored in Firebase)
//   */
//   return {
//     link: function (scope, elem, attrs) {
//       var safename = attrs.fpSrc.replace(/\.|\#|\$|\[|\]|-|\//g, "");
//       var dataRef = new Firebase( [scope.firebaseUrl, 'images', safename].join('/') );
//       elem.attr('alt', attrs.fpSrc);
//       dataRef.once('value', function (snapshot) {
//         var image = snapshot.val();
//         if (!image) {
//           $log.log('It appears the image ' + attrs.fpSrc + ' does not exist.');
//         }else{
//           elem.attr('src', image.data);
//         }
//       });
//     },
//     restrict: 'A'
//   };
// }]);
"use strict";

var cov_18j13nm77s = function () {
  var path = "/Users/ryanluton/Developer/divcon/divcon-tools/src/directives/fp-src.js",
      hash = "186170451148d3ec116d275c94a4ca5946060523",
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/ryanluton/Developer/divcon/divcon-tools/src/directives/fp-src.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "332fd63041d2c1bcb487cc26dd0d5f7d97098a6c"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();